import { render, staticRenderFns } from "./projectNeed.vue?vue&type=template&id=4c00f636&scoped=true"
import script from "./projectNeed.vue?vue&type=script&lang=js"
export * from "./projectNeed.vue?vue&type=script&lang=js"
import style0 from "./projectNeed.vue?vue&type=style&index=0&id=4c00f636&prod&lang=css"
import style1 from "./projectNeed.vue?vue&type=style&index=1&id=4c00f636&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00f636",
  null
  
)

export default component.exports